import { useEffect, useState } from "react";
import { Droppable, DroppableProps } from "react-beautiful-dnd";

/**
 * Wrapper che risolve l'incompatibilità tra react-beautiful-dnd e React 18 StrictMode.
 * StrictMode monta/smonta i componenti due volte in sviluppo, causando la perdita
 * della registrazione del Droppable. Questo wrapper ritarda il rendering fino al
 * secondo frame, dopo che StrictMode ha completato il ciclo di mount.
 */
// PROG-DND/DND-1 — under jest / jsdom, requestAnimationFrame is queued but
// doesn't run synchronously inside the initial render flush, so tests that
// query for descendants of a Droppable immediately after `render()` would
// never see them while the rAF gate is still pending. The gate only matters
// for React 18 StrictMode dev double-mount; in production it costs at most
// one frame regardless. Bypassing it in the test env keeps existing test
// suites working without having to switch unrelated specs to async
// `findByTestId` queries.
const SKIP_RAF_GATE =
  typeof process !== "undefined" && process.env?.NODE_ENV === "test";

export default function StrictModeDroppable({ children, ...props }: DroppableProps) {
  const [enabled, setEnabled] = useState(SKIP_RAF_GATE);

  useEffect(() => {
    if (SKIP_RAF_GATE) return;
    const frame = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(frame);
      setEnabled(false);
    };
  }, []);

  if (!enabled) return null;

  return <Droppable {...props}>{children}</Droppable>;
}
